module.exports = __webpack_public_path__ + "static/media/mediaGridIconInactive.f8e6353b.svg";